var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bbp-filter-popup"},[_c('BBPSelectImage',{attrs:{"options":_vm.options,"label":"username","value":_vm.value,"isSelectUserFilter":true},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30cf85ec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/BBPTable/BBPFilterPopup/BBPFilterPopup.vue
// module id = null
// module chunks = 